export default __webpack_public_path__ + "static/media/fire-circle-tablet.28cc9038.png";